import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import currencyConstants from "../constants/currencyConstants";

const getCurrencies = () => api.get(Endpoint.retrieveCurrencies);

function* retrieveCurrencies() {
  try {
    const response: AxiosResponse = yield call(getCurrencies);
    yield put({
      type: currencyConstants.GET_CURRENCIES_LIST_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: currencyConstants.GET_CURRENCIES_LIST_FAILURE, err: e });
  }
}

function* currencySaga() {
  yield all([
    takeEvery(currencyConstants.GET_CURRENCIES_LIST, retrieveCurrencies),
  ]);
}

export default currencySaga;
